import { BenefitTableExample } from 'core/service/pdf-generation/products/investment/components'

export const BenefitTableExampleGroup = (props) => {
  const { cashFlowByExpectedReturn } = props
  const EXPECTED_RETURN_RATES = Object.keys(cashFlowByExpectedReturn).sort()
  return EXPECTED_RETURN_RATES.map((rate, index) => {
    const cashFlows = props.cashFlowByExpectedReturn[rate]
    return BenefitTableExample({ ...props, cashFlows }, index + 1, parseInt(rate))
  })
}
